module.exports = __webpack_public_path__ + "img/example.a21e7ff5.png";